import React from 'react';
import { Tooltip, IconButton, Checkbox, FormControlLabel } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import Swal from 'sweetalert2';

const AiContentAudit = ({ checked, onChange, auditCreditCost = 0 }) => {

    const handleCheckChange = (e) => {
        const isChecking = e.target.checked;

        if (isChecking && auditCreditCost > 0) {
            Swal.fire({
                title: 'Enable AI Content Audit?',
                html: `<p style="margin-bottom:5px">Enabling AI Content Audit will add <strong style="color:#ffa21f">${auditCreditCost} credits</strong> to your generation cost.</p>
                <p>Audit AI-generated content to ensure accuracy, credibility, and trust before publishing. </p>
                `,
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Enable',
                cancelButtonText: 'Cancel',
                customClass: {
                    popup: 'modal_class_success',
                },
                confirmButtonColor: '#ffa21f',
            }).then((result) => {
                if (result.isConfirmed) {
                    onChange(true);
                }
            });
        } else {
            onChange(false);
        }
    };

    const showAuditInfo = () => {
        Swal.fire({
            title: "AI Content Audit Disclaimer",
            html: `
        <div style="text-align:left;">
          <p>
            AI-generated content may occasionally contain inaccuracies or
            hallucinations.
          </p>

          <br/>

          <p>
            We recommend auditing all generated content before publishing
            or using it.
          </p>

          <br/>

          <p>
            This audit is also performed by AI and may not detect every
            issue, so a final human review is always recommended.
          </p>
        </div>
      `,
            icon: "info",
            confirmButtonText: "Got it",
            confirmButtonColor: "#ffa21f",
            customClass: {
                popup: "modal_class_success",
            },
        });
    };

    return (
        <div className="d-flex align-items-center mb-4 justify-content-center">
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={handleCheckChange}
                        sx={{
                            color: '#fff',
                            '&.Mui-checked': {
                                color: '#ffa21f', // Assuming warning/orange color used in app
                            },
                        }}
                    />
                }
                label="AI Content Audit"
                sx={{
                    color: '#fff',
                    marginRight: '0px'
                }}
            />
            <IconButton
                size="small"
                sx={{ color: "#ffa21f" }}
                onClick={showAuditInfo}
            >
                <InfoIcon fontSize="small" />
            </IconButton>
        </div>
    );
};

export default AiContentAudit;
